import { useState } from 'react'
import { ethers } from 'ethers'
import {
  Nav,
  Navbar,
  NavDropdown,
  Form,
  FormControl,
  Button,
} from 'react-bootstrap'
import Blockies from 'react-blockies'

import '../styles/hamburger.scss'
//import { ReactComponent as Logo } from '../pets.svg'
import logo from '../logo.png'

import config from '../config.json'
const { ethereum } = window

const Navigation = ({ account, setAccount, chainId }) => {
  const [isActive, setIsActive] = useState(false)

  const connectHandler = async () => {
    const accounts = await ethereum.request({
      method: 'eth_requestAccounts',
    })
    setAccount(ethers.utils.getAddress(accounts[0]))
  }

  const networkHandler = async e => {
    try {
      // Switch to the selected network
      await ethereum.request({
        method: 'wallet_switchEthereumChain',
        params: [{ chainId: e.target.value }],
      })
    } catch (switchError) {
      // This error code indicates that the chain has not been added to MetaMask.
      if (switchError.code === 4902) {
        try {
          await ethereum.request({
            method: 'wallet_addEthereumChain',
            params: [
              {
                chainId: e.target.value,
                rpcUrls: ['https://eth-rpc-api-testnet.thetatoken.org/rpc'],
              },
            ],
          })
        } catch (error) {
          console.error("AJ's Error: failed to add chain to MetaMask", error)
        }
      } else {
        console.log(
          `AJ - ${switchError.code}: failed to switch networks `,
          switchError
        )
      }
    }
  }
  /*
  <Logo alt="logo" className="d-inline-block align-top mx-3" />
  
          <Navbar.Brand href="#">AI Pet Generator</Navbar.Brand>
  */
  return (
    <Navbar className="mb-3 mt-4">
      <div
        className="d-flex justify-content-start"
        style={{ alignItems: 'center' }}
      >

        <div className="d-flex justify-content-center">
          <a href="#">
            <img src={logo} width={50} />
          </a>
            <Navbar.Brand href="#" style={{color:'white'}}>AI NFT Generator</Navbar.Brand>
        </div>
      </div>

      <div
        className="d-flex justify-content-end"
        style={{ alignItems: 'center' }}
      >

        {account ? (
          <Navbar.Text className="d-flex align-items-center">
            {account.slice(0, 5) + '...' + account.slice(38, 42)}
            <Blockies
              seed={account}
              size={10}
              scale={3}
              color="#2187D0"
              bgColor="#F1F2F9"
              spotColor="#767F92"
              className="identicon mx-2"
            />
          </Navbar.Text>
        ) : (
          <Button className="btn btn-success" onClick={connectHandler}>Connect</Button>
        )}
      </div>
    </Navbar>
  )
}

export default Navigation
